module.exports = "<app-faturamento *ngIf=\"contaId\" [contaId]=\"contaId\"></app-faturamento>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/faturamento/meu-faturamento.component.html
// module id = ./src/app/modules/faturamento/meu-faturamento.component.html
// module chunks = main